export const slugify = (text) => {
  return text
    .toString()
    .toLowerCase()
    .replace(/\s+/g, '-')       
    .replace(/[^\w-]+/g, '')     
    .replace(/--+/g, '-')       
    .replace(/^-+/, '')         
    .replace(/-+$/, '');        
};

export const mapPostTypeToCategory = (postType) => {
switch (postType.toLowerCase()) {
  case 'lostanimal':
    return 'lost-animal';
  case 'foundanimal':
    return 'found-animal';
  case 'psa':
    return 'psa';
  case 'petservice':
    return 'pet-service';
  default:
    return postType.toLowerCase();
}
}; 

export const formatDate = (timestamp) => {
if (!timestamp) return 'Unknown';

// Attempt to parse as a number (if the timestamp is in seconds or milliseconds)
let date = new Date(Number(timestamp));
if (isNaN(date.getTime())) {
  // Try multiplying by 1000 if it's a seconds timestamp
  date = new Date(Number(timestamp) * 1000);
}

// Fallback for ISO string or other formats
if (isNaN(date.getTime())) {
  date = new Date(timestamp);
}

const year = date.getUTCFullYear();
const month = date.getUTCMonth() + 1;
const day = date.getUTCDate();

  return `${month}/${day}/${year}`;
};

export const formatPhoneNumber = (phoneNumber) => {
if (!phoneNumber) return 'N/A';

// Strip all non-numeric characters
const cleaned = ('' + phoneNumber).replace(/\D/g, '');

// Format based on length
if (cleaned.length === 10) {
  return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
} else if (cleaned.length === 11 && cleaned.startsWith('1')) {
  // For US numbers that start with country code '1'
  return `+1 (${cleaned.slice(1, 4)}) ${cleaned.slice(4, 7)}-${cleaned.slice(7)}`;
} else {
  // Return original if formatting isn't possible
  return phoneNumber;
}
};

export const filterValidFields = (input, validFields) => {
return Object.keys(input).reduce((filteredInput, key) => {
  if (validFields.includes(key)) {
    filteredInput[key] = input[key];
  }
  return filteredInput;
}, {});
};

// Define valid fields for each type
export const VALID_FIELDS_BY_CATEGORY = {
psa: ['title', 'description', 'location', 'startDate', 'endDate'],
'lost-animal': [
  'contactName', 'contactPhone', 'contactEmail', 'location',
  'animalName', 'animalType', 'breed', 'colorMarkings',
  'dateLost', 'rewardAmount', 'sex', 'lastSeen', 'approachable', 'estimatedWeight',
],
'found-animal': [
  'contactName', 'contactPhone', 'contactEmail', 'location',
  'animalName', 'animalType', 'breed', 'colorMarkings', 'dateFound', 'sex', 'foundNear', 'estimatedWeight'
],
'pet-service': ['title', 'description', 'location'],
};

// urlHelper
export const buildSubcategoryURL = (mainCategory, subcategory) => {
  const subcategoryLabel = subcategory.searchLabel || subcategory.key; // Use a serializable identifier
  return `/search/${mainCategory}?subcategory=${encodeURIComponent(subcategoryLabel)}`;
};
